export const validatePassword = (password) => {
  const errors = [];
  
  // Check minimum length
  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }

  // Check for uppercase letter
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }

  // Check for lowercase letter
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }

  // Check for number
  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }

  // Check for special character
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Password must contain at least one special character');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const getPasswordStrength = (password) => {
  let strength = 0;
  
  // Length contribution (up to 25%)
  strength += Math.min(password.length * 2.5, 25);
  
  // Uppercase letters (25%)
  if (/[A-Z]/.test(password)) strength += 25;
  
  // Lowercase letters (25%)
  if (/[a-z]/.test(password)) strength += 25;
  
  // Numbers (15%)
  if (/\d/.test(password)) strength += 15;
  
  // Special characters (10%)
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) strength += 10;

  return strength;
};
